<template>
  <div class="uk-container">
    <div
      class="uk-card uk-card-default uk-card-body"
      style="z-index: 980;"
      uk-sticky="bottom: #offset"
    >
      <button
        class="uk-button uk-button-primary"
        :disabled="!changed"
        @click="updateColors"
      >Save Changes</button>
    </div>
    <h2>Add Color</h2>
    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>Color Name</th>
          <th>Category</th>
          <th>Hex</th>
          <th>Color Set</th>
          <th>Delete Color</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input class="uk-input" type="text" placeholder="Color Name" v-model="newColor.colorName" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="Category" v-model="newColor.category" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="#Hex" v-model="newColor.hex" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="Color Set" v-model="newColor.colorSet" />
          </td>
          <td>
            <button class="uk-button uk-button-primary" @click="addColor()">Add</button>
          </td>
        </tr>
      </tbody>
    </table>
    <h2>Edit Colors</h2>
    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>Color Name</th>
          <th>Category</th>
          <th>Hex</th>
          <th>Color Set</th>
          <th>Delete Color</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(color, index) in colors">
          <td>
            <input class="uk-input" type="text" placeholder="Input" v-model="color.colorName" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="Input" v-model="color.category" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="Input" v-model="color.hex" />
          </td>
          <td>
            <input class="uk-input" type="text" placeholder="Input" v-model="color.colorSet" />
          </td>
          <td>
            <button class="uk-button uk-button-danger" @click="deleteColor(index)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
//import ColorsService from "@/services/ColorsService";
import firebase from "firebase";

export default {
  name: "adminColors",

  data() {
    return {
      colors: [],
      newColor: {
        colorName: "",
        category: "",
        hex: "",
        colorSet: ""
      },
      changed: false
    };
  },

  methods: {
    deleteColor(index) {
      this.colors.splice(index, 1);
    },
    addColor(){
      this.colors.push(this.newColor)
      this.newColor = {
        colorName: "",
        category: "",
        hex: "",
        colorSet: ""
      }
    },
    updateColors() {
      let self = this;
      const colors = { "knotty-colors": this.colors };
      var colorsRef = firebase
        .firestore()
        .collection("colors")
        .doc("0");
      colorsRef
        .update(colors)
        .then(function() {
          self.changed = false;
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    }
  },

  computed: {},

  watch: {
    colors: {
      handler(val) {
        this.changed = true;
      },
      deep: true
    }
  },
  mounted: function() {
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          let c = doc.data();
          console.log(c["knotty-colors"]);
          for (const i of c["knotty-colors"]) {
            i.show = true;
          }
          function isKnotty(color) {
            return color.colorSet == "Knotty";
          }
          const knottyColors = c["knotty-colors"];
          self.colors = knottyColors;
          setTimeout(() => {
            self.changed = false;
          }, 500);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  }
};
</script>





// WEBPACK FOOTER //
// src/components/admin/AdminColors.vue